module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selection && _vm.selection.length > 0) ? _c('div', {
    class: {
      'search-filters': true, 'mobile-filter': _vm.isMobile
    }
  }, [_c('div', {
    class: {
      'search-filters-header': true,
      'list-closed': _vm.isMobile && !_vm.showList,
    }
  }, [_c('h3', [_vm._v("Filters")]), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "search-filters-header-icon wwf-no-select",
    on: {
      "click": function($event) {
        _vm.toggleShowList()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-bars fa-fw"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.isMobile || _vm.showList) ? _c('div', {
    staticClass: "search-filters-container"
  }, [_c('div', {
    staticClass: "search-filters-tags"
  }, _vm._l((_vm.selected), function(item) {
    return _c('div', {
      staticClass: "search-filters-tag",
      on: {
        "click": function($event) {
          _vm.deleteFilter(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.label))])])
  })), _vm._v(" "), _vm._l((_vm.selection), function(filter) {
    return _c('div', {
      staticClass: "search-filter"
    }, [_c('h4', [_vm._v(_vm._s(filter.label))]), _vm._v(" "), _c('div', {
      staticClass: "search-filter-items"
    }, [_vm._l((_vm.reducedValues(filter.values)), function(item) {
      return _c('div', {
        staticClass: "search-filter-item"
      }, [_c('div', {
        staticClass: "search-filter-item-name",
        on: {
          "click": function($event) {
            _vm.selectFilter(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.label) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "search-filter-item-count",
        on: {
          "click": function($event) {
            _vm.selectFilter(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.count) + "\n          ")])])
    }), _vm._v(" "), _vm._l((_vm.expandedValues(filter.values)), function(item) {
      return (_vm.expanded) ? _c('div', {
        staticClass: "search-filter-item"
      }, [_c('div', {
        staticClass: "search-filter-item-name",
        on: {
          "click": function($event) {
            _vm.selectFilter(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.label) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "search-filter-item-count",
        on: {
          "click": function($event) {
            _vm.selectFilter(item)
          }
        }
      }, [_vm._v("\n            " + _vm._s(item.count) + "\n          ")])]) : _vm._e()
    }), _vm._v(" "), _c('button', {
      staticClass: "expand-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.expanded = !_vm.expanded
        }
      }
    }, [(!_vm.expanded) ? _c('span', [_vm._v("More")]) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('span', [_vm._v("Less")]) : _vm._e()])], 2)])
  })], 2) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14bc5b22","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!./~/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./src/components/search/SearchFilter.vue
// module id = 612
// module chunks = 0